module.exports = __webpack_public_path__ + "img/code-analysis.e2ddc0ae.jpeg";